import script from "./dashboard-no-data.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-no-data.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__